import { Provider } from '~/entities/provider'
import {
  GET_PROVIDERS_SUCCESS,
  GET_PROVIDERS_ERROR,
  UPDATE_PROVIDER_PRACTICING_STATES,
} from '../actions/actionTypes'
import type { ProvidersAction } from '../actions/providers'

const INITIAL_STATE: Provider[] = []

const providers = (state: Provider[] = INITIAL_STATE, action: ProvidersAction): Provider[] => {
  switch (action.type) {
    case GET_PROVIDERS_SUCCESS:
      return action.providers
    case GET_PROVIDERS_ERROR:
      return [...state]
    case UPDATE_PROVIDER_PRACTICING_STATES:
      return state.map(provider => {
        if (provider.id == action.payload.id && provider.provider_fields) {
          return {
            ...provider,
            provider_fields: {
              ...provider.provider_fields,
              practicing_states: action.payload.practicingStates,
            },
          }
        } else {
          return provider
        }
      })
    default:
      return state
  }
}

export default providers
